export const studioData = {
  name: "LK STUDIO",
  cvr: "46439066",
  email: "info@lkstudioems.com",
  phone: "28852282",
  phoneDisplay: "28 85 22 82",
  address: "Engtoftevej 8, 1816 Frederiksberg C",
  logo: "https://assets.auxodev.dk/assets/766f1303-2002-4537-8cbb-d8bd7f1c5c0f/a43cda1a-840d-41cf-8281-f04934d53c03.jpg"
};

export const navLinks = [
  { name: "Forside", path: "/" },
  { name: "Fysioterapi", path: "/fysioterapi" },
  { name: "EMS træning", path: "/om-ems-traening" },
  { name: "Priser", path: "/priser" },
  { name: "LK studio team", path: "/om-os" },
  { name: "Galleri", path: "/galleri" },
  { name: "Kontakt", path: "/kontakt" },
];

export const services = [
  {
    title: "EMS træning",
    description: "EMS træning er ekstremt effektiv, men samtidig skånsom styrketræning, som foregår ved at de store muskelgrupper bliver intensivt stimuleret af elektriske impulser.",
    link: "/personlig-traening",
    icon: "Activity",
  },
  {
    title: "Fysioterapi",
    description: "Hos LK Studio tilbyder vi fysioterapeutisk behandling og genoptræning, der tager udgangspunkt i dine individuelle behov og mål.",
    link: "/fysioterapi",
    icon: "Stethoscope",
  },
  {
    title: "Kostvejledning",
    description: "Bliv stærk både udefra og indefra med vores pakkeforløb, hvor vi kombinerer EMS træning med personlig kostvejledning.",
    link: "/forloeb",
    icon: "Apple",
  },
];

export const team = [
  {
    name: "Line",
    role: "Founder af LK Studio\ncertificeret fysioterapeut\nEMS instruktør",
    description: "Jeg er en erfaren fysioterapeut med speciale i muskuloskeletale problematikker. Jeg har 12 års erfaring fra privatklinik og ser kroppen som en helhed.",
    image: "https://assets.auxodev.dk/assets/766f1303-2002-4537-8cbb-d8bd7f1c5c0f/09230a49-8e0a-4270-b212-ef3872e2dc31.jpg",
  },
  {
    name: "Marie",
    role: "EMS instruktør & Kostvejleder",
    description: "Marie hjælper dig i gang med nye sunde vaner, som er realistiske og tilpasset netop dit liv.",
    image: "https://assets.auxodev.dk/assets/766f1303-2002-4537-8cbb-d8bd7f1c5c0f/b650fed2-ca64-4bef-8d07-9a56f9d2fdad.jpg",
  },
];

export const cases = [
  {
    id: 1,
    name: "Resultater",
    title: "Mærk og se forskellen",
    summary: "De fleste kan mærke forskel efter blot få gange, og allerede efter ca. 7-10 træninger begynder de ydre fysiske forandringer at ses.",
    fullStory: "Ved traditionel træning bruger du typisk kun mellem 40 – 70% af dit styrkepotentiale. Ved EMS-træning bruger du ca. 90% af dit potentiale. Gennem EMS dragten øges dine muskelsammentrækninger i de øvelser du laver. På den måde opnår du en mere intensiv og effektiv træning og på langt kortere tid end traditionel træning.",
    image: "https://assets.auxodev.dk/assets/766f1303-2002-4537-8cbb-d8bd7f1c5c0f/c4aa9dd3-b5aa-4d36-a24c-822682538da7.jpg",
  },
];

export const packages = [
  {
    title: "Opstartstilbud",
    description: "Gælder kun for nye kunder",
    price: "1500,-",
    features: ["1 x prøvetræning", "4 x Ems træning", "Xbody træningssæt"],
    cta: "Book nu",
  },
  {
    title: "Prøvetræning",
    description: "Du kan låne et Xbody træningssæt til prøvetræningen",
    price: "150,-",
    features: ["20 min. intensiv træning", "Personlig træner", "Udstyr inkluderet"],
    cta: "Book prøvetime",
  },
  {
    title: "Fysioterapi",
    description: "Konsultation & behandling",
    price: "600,-",
    features: ["45 min. session", "Grundig undersøgelse", "Behandlingsplan"],
    cta: "Book tid",
  },
];

export const images = {
  hero: "https://assets.auxodev.dk/assets/766f1303-2002-4537-8cbb-d8bd7f1c5c0f/d362e601-c98c-4756-b121-cf002b4687c9.gif",
  physio: "https://assets.auxodev.dk/assets/766f1303-2002-4537-8cbb-d8bd7f1c5c0f/0c96b9e0-ed0f-4945-9b9c-cb0f556e3144.jpg",
  training: "https://assets.auxodev.dk/assets/766f1303-2002-4537-8cbb-d8bd7f1c5c0f/acf24aad-5bd9-4c13-ac2b-a8f96ec93620.jpg",
  line: "https://assets.auxodev.dk/assets/766f1303-2002-4537-8cbb-d8bd7f1c5c0f/a503eab0-e980-4d56-9b36-5143fea085ab.jpg",
  details: "https://assets.auxodev.dk/assets/766f1303-2002-4537-8cbb-d8bd7f1c5c0f/2333d257-a4d9-4629-9e4c-4f90d7df46b9.jpg",
};

export const metadata = {
  home: {
    title: "LK STUDIO | EMS træning & Fysioterapi",
    description: "LK STUDIO EMS - kom i form med 20 minutters effektiv og skånsom træning. Gode resultater med kun 2 x 20 minutters træning om ugen.",
  },
  physio: {
    title: "Fysioterapi & massage | LK STUDIO",
    description: "Velkommen til personlig konsultation hos LK STUDIO's dygtige fysioterapeut Line.",
  },
  ems: {
    title: "EMS på Frederiksberg | LK STUDIO",
    description: "Hos LK STUDIO tilbyder vi professionel EMS træning i hjertet af Frederiksberg.",
  },
  pricing: {
    title: "Priser | LK STUDIO",
    description: "Book en EMS prøvesession i LK STUDIO for kun 150,-",
  },
  about: {
    title: "LK STUDIO Team | LK STUDIO",
    description: "Mød teamet bag LK STUDIO EMS.",
  },
  contact: {
    title: "Kontakt | LK STUDIO",
    description: "Her finder du LK STUDIO EMS personlig træning på Frederiksberg.",
  },
};
